import { render, staticRenderFns } from "./PresenceInfo.vue?vue&type=template&id=423b61b0&scoped=true&"
import script from "./PresenceInfo.vue?vue&type=script&lang=ts&"
export * from "./PresenceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PresenceInfo.vue?vue&type=style&index=0&id=423b61b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b61b0",
  null
  
)

export default component.exports